import { render } from "./curriculumVitae.vue?vue&type=template&id=4f291226&scoped=true"
import script from "./curriculumVitae.vue?vue&type=script&lang=js"
export * from "./curriculumVitae.vue?vue&type=script&lang=js"

import "./curriculumVitae.vue?vue&type=style&index=0&id=4f291226&scoped=true&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f291226"]])

export default __exports__